import {
  buildProtheusPartyKey,
  type ProtheusPartyReference,
  type ProtheusRecipientOption,
} from '@/entities/Protheus';

export type PhysicalRecipientOption = ProtheusRecipientOption & ProtheusPartyReference;

export const toPhysicalRecipientOption = ({
  code,
  store,
  name,
}: ProtheusPartyReference & { name: string }): PhysicalRecipientOption => ({
  id: buildProtheusPartyKey({ code, store }),
  code,
  store,
  name,
});

export interface PhysicalRecipientRow {
  id: string;
  recipientId: string;
  copies: number | null;
  sendDate: Date | null;
  isDatePickerOpen: boolean;
}

export interface SelectedDocumentEntry {
  documentRevisionId: number;
  prefix: string;
  title: string | null;
  revision: number;
  originalFileName: string;
  fileSizeBytes: number;
  clientRecipients: PhysicalRecipientRow[];
  supplierRecipients: PhysicalRecipientRow[];
}

let fallbackIdCounter = 0;

const createPhysicalRecipientRowId = () => {
  const cryptoApi = globalThis.crypto;

  if (cryptoApi?.randomUUID) {
    return `physical-recipient-${cryptoApi.randomUUID()}`;
  }

  if (cryptoApi?.getRandomValues) {
    const bytes = new Uint8Array(16);
    cryptoApi.getRandomValues(bytes);
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    return `physical-recipient-${hex}`;
  }

  fallbackIdCounter += 1;
  return `physical-recipient-fallback-${Date.now()}-${fallbackIdCounter}`;
};

export const createPhysicalRecipientRow = (): PhysicalRecipientRow => ({
  id: createPhysicalRecipientRowId(),
  recipientId: '',
  copies: 1,
  sendDate: null,
  isDatePickerOpen: false,
});
